<div
    class="sidebar"
    appDynamicScreenHeight
    [dshdConfig]="{ scrollable: true }"
>
    <div
        class="grid"
        *ngIf="applicationDetails$ | async as applicationDetails"
    >
        <div class="grid gap-4 sidebar-child">
            <!--    DEAL STATUS CHANGE DROPDOWN    -->
            <app-deal-status-change-dropdown
                *ngIf="(permittedToManuallyChangeStatus$ | async); else declineApproveFundedButtons"
                [deal]="(applicationDetails$ | async).deal"
                class="mb-3"
            ></app-deal-status-change-dropdown>

            <!--    DECLINE, APPROVE, FUNDED BUTTONS    -->
            <ng-template #declineApproveFundedButtons>
                <div class="pb-2">
                    <button
                        mat-stroked-button
                        (click)="openDeclineDialog()"
                        [disabled]="!isStatusContractIn"
                    >
                        Decline
                    </button>
                    <button
                        mat-flat-button
                        color="primary"
                        class="ml-4"
                        (click)="changeDealStatus('funding')"
                        [disabled]="!isStatusContractIn"
                    >
                        Approve
                    </button>
                    <button
                        #fundedButton
                        mat-flat-button
                        color="primary"
                        class="ml-4"
                        (click)="changeDealStatus('funding', true)"
                        [disabled]="applicationDetails?.deal?.status !== 'funding'"
                    >
                        Funded
                    </button>
                </div>
            </ng-template>

            <!--    DEAL ASSIGNMENT DROPDOWN    -->
            <div *ngIf="portalUsers$ | async">
                <app-assignment-dropdown
                    [usersAssigned]="assignmentsArray || []"
                    [dealId]="applicationDetails.deal.id"
                    [portalUsers]="portalUsers$ | async"
                >
                </app-assignment-dropdown>
            </div>
        </div>

        <!--    OFFER    -->
        <div class="sidebar-child pt-8">
            <h2>Offer</h2>
            <div>Offer sent</div>
            <div class="text-sm font-normal mb-2">
                {{
                    (mostRecentApproval?.created
                        | date : "MMMM d, y 'at' h:mma") || "---"
                }}
            </div>

            <div>Offer expires</div>
            <div class="text-sm font-normal mb-2">
                {{
                    (mostRecentApproval?.expires
                        | date : "MMMM d, y 'at' h:mma") || "---"
                }}
            </div>

            <div>Offer accepted</div>
            <div class="text-sm font-normal mb-6">
                {{
                    (mostRecentOffer?.accepted
                        | date : "MMMM d, y 'at' h:mma") || "---"
                }}
            </div>
        </div>

        <!--    DOCUMENTS    -->
        <div class="sidebar-child divider">
            <app-documents-quick-view></app-documents-quick-view>
        </div>

        <!--    ESIGNATURE STATUS   -->
        <div *ngIf="(hasInstantContractsFeature$ | async) && ((signers$ | async)?.length > 0)" class="sidebar-child divider">
            <app-esign-status
                [signers]="(signers$ | async)"
                [dealId]="dealId">
            </app-esign-status>
        </div>

        <!--    NOTES    -->
        <div class="border-t-4 sidebar-child divider">
            <app-deal-notes
                [dealId]="applicationDetails?.deal?.id"
            ></app-deal-notes>
        </div>

        <!--    FUNDING DESK    -->
        <div *ngIf="(hasFundingDeskFeature$ | async)" class="sidebar-child divider">
            <app-funding-desk-smart
                [dealId]="dealId"
                [newTheme]="true"
            ></app-funding-desk-smart>
        </div>
    </div>
</div>
